import { createInvoiceDetailState } from '@/composables/invoices/detail/state';
import { invoiceDetailComputed } from '@/composables/invoices/detail/computed';
import { invoiceDetailMethods } from '@/composables/invoices/detail/methods';
import { invoiceDetailSendEmailMethods } from '@/composables/send/sendEmailMethods';

const mergedInvoiceDetailComputed = {
  ...invoiceDetailComputed,
};

const mergedInvoiceDetailMethods = {
  ...invoiceDetailMethods,
  ...invoiceDetailSendEmailMethods,
};

export {
  createInvoiceDetailState,
  mergedInvoiceDetailComputed as invoiceDetailComputed,
  mergedInvoiceDetailMethods as invoiceDetailMethods,
};
